import {action} from 'mobx';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {ValidationErrorDescription} from '@mintdata-wsp/common/controllers/network/generated/responses/ValidationErrorDescription';
import {
    FlowValidationError,
    MessageSeverity,
    MessageSource,
    SimulationId,
    SimulationMessage
} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';

export class FlowSimulationMessagesController
{
    @action
    public logMessage(simulationId:SimulationId,
                      message:string,
                      severity:MessageSeverity = MessageSeverity.Info,
                      source:MessageSource = MessageSource.UI):void
    {
        this._logMessage(simulationId, message, severity, source);
    }

    @action
    public logProblem(simulationId:SimulationId,
                      message:string,
                      severity:MessageSeverity,
                      source:MessageSource = MessageSource.UI):void
    {
        this._logMessage(simulationId, message, severity, source);
    }

    @action
    public logError(simulationId:SimulationId,
                    errorMessage:string,
                    source:MessageSource = MessageSource.UI):void
    {
        this._logMessage(simulationId, errorMessage, MessageSeverity.Error, source);
    }

    @action
    public clearMessages(simulationId:SimulationId)
    {
        const {flowSimulation} = commonControllers;

        flowSimulation.clearMessages(simulationId);
    }

    public onMessageFromCloud(simulationId:SimulationId, logMessage:any):void
    {
        if( !logMessage )
        {
            return;
        }

        const severity = this._toMessageSeverity(logMessage.level.toLowerCase());
        const timestamp = new Date(logMessage['@timestamp']).getTime() as number;
        const message = logMessage.output;

        this.logProblem(simulationId, message, severity, MessageSource.Cloud);
    }

    protected _logMessage(simulationId:SimulationId,
                          message:string,
                          severity:MessageSeverity,
                          source:MessageSource,
                          flowErrorRef?:FlowValidationError,
                          cloudFlowErrorRef?:ValidationErrorDescription)
    {
        const {flowSimulation} = commonControllers;

        const simulationMessage = new SimulationMessage(message, severity, source, flowErrorRef, cloudFlowErrorRef);

        flowSimulation.addMessage(simulationId, simulationMessage);
    }

    protected _toMessageSeverity(level:string):MessageSeverity
    {
        if( level === 'info' )
        {
            return MessageSeverity.Info;
        }
        else if( level === 'error' )
        {
            return MessageSeverity.Error;
        }
        else if( level === 'warn' || level === 'warning' )
        {
            return MessageSeverity.Warn;
        }
        else
        {
            return MessageSeverity.Verbose;
        }
    }
}

export interface ILogMessage
{
    // "output" : "Cannot parse response from server: Unexpected character '{' (code 123) in prolog; expected '<'",
    // "componentType" : "m.v.c.BakeryComponentAdapter",
    // "@timestamp" : "2018-03-25T13:35:17.667+0300",
    // "componentId" : "563c72a1-4a4a-4244-9636-78e33864adea",
    // "subscriber" : "5360410d-1d3d-443c-9e2c-8da1f9e413cf",
    // "level" : "ERROR",
    // "topology" : "5360410d-1d3d-443c-9e2c-8da1f9e413cf",
    // "messageSource" : "topology",
    // "topic" : "5360410d-1d3d-443c-9e2c-8da1f9e413cf.ERROR",
    // "exceptionClass" : null,
    // "stackTrace" : [ ],
    // "exceptionMessage" : null

    messageSource:'topology';
    level:'ERROR' | 'INFO' | 'WARN',
    componentId:string;
    componentType:string;
    output:string;
}
